import { render } from "./QCMQuestionContainer.vue?vue&type=template&id=5d3aa38a&scoped=true"
import script from "./QCMQuestionContainer.vue?vue&type=script&lang=js"
export * from "./QCMQuestionContainer.vue?vue&type=script&lang=js"

import "./QCMQuestionContainer.vue?vue&type=style&index=0&id=5d3aa38a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d3aa38a"]])

export default __exports__